import { createReducer, on } from "@ngrx/store";
import { initialPurchaseFormState } from "./purchase.state";
import * as PurchaseFormActions from "./purchase.actions";

export const purchaseFormReducer = createReducer(
  initialPurchaseFormState,
  on(PurchaseFormActions.savePurchaseHeader, (state, { header }) => ({
    ...state,
    header,
  })),
  on(PurchaseFormActions.savePurchaseItems, (state, { items }) => ({
    ...state,
    items,
  })),
  on(PurchaseFormActions.addPurchaseItem, (state, { item }) => ({
    ...state,
    items: [...state.items, item],
  })),
  on(PurchaseFormActions.clearPurchaseForm, () => initialPurchaseFormState),

  on(PurchaseFormActions.createPurchase, (state) => ({
    ...state,
    loading: true,
    error: null,
    saveSuccess: false,
  })),
  on(PurchaseFormActions.createPurchaseSuccess, (state, { response }) => ({
    ...state,
    loading: false,
    saveSuccess: true,
    error: null,
    createdPurchase: response, // Store the created purchase response
  })),
  on(PurchaseFormActions.createPurchaseFailure, (state, { error }) => ({
    ...state,
    loading: false,
    saveSuccess: false,
    error: typeof error === 'string' ? error : (error?.error?.message || error?.message || 'Failed to create purchase.'),
  })),

  // ------------------------
  // Update Purchase
  on(PurchaseFormActions.updatePurchase, (state) => ({
    ...state,
    loading: true,
    error: null,
    saveSuccess: false,
  })),
  on(PurchaseFormActions.updatePurchaseSuccess, (state, { response }) => ({
    ...state,
    loading: false,
    saveSuccess: true,
    error: null,
    header: response,
  })),
  on(PurchaseFormActions.updatePurchaseFailure, (state, { error }) => ({
    ...state,
    loading: false,
    saveSuccess: false,
    error,
  })),

  // ------------------------
  // Load By ID (Edit)
  on(PurchaseFormActions.loadPurchaseById, (state) => ({
    ...state,
    loading: true,
    error: null,
  })),
on(PurchaseFormActions.loadPurchaseByIdSuccess, (state, { purchase }) => ({
  ...state,
  loading: false,
  error: null,
  header: purchase,
  items: purchase.items ?? [],
  selectedPurchase: purchase, 
})),
  on(PurchaseFormActions.loadPurchaseByIdFailure, (state, { error }) => ({
    ...state,
    loading: false,
    error,
  })),

  // ------------------------
  // Last Purchase Item Details
  on(
    PurchaseFormActions.loadLastPurchaseDetailsSuccess,
    (state, { rowIndex, itemDetails }) => ({
      ...state,
      itemDetailsByRow: {
        ...state.itemDetailsByRow,
        [rowIndex]: itemDetails,
      },
    })
  )
);
